import script from "./EventsVue.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsVue.vue?vue&type=script&setup=true&lang=js"

import "./EventsVue.vue?vue&type=style&index=0&id=69b2f7b4&lang=scss"

const __exports__ = script;

export default __exports__